import {barDrinks, barTasks, homeDrinks, homeTasks} from "../constants/Constants";

export function generateTasks(edition) {
    if (edition === 'bar') {
        return barTasks;
    } else {
        return homeTasks;
    }
}

export function generateDrinks(edition) {
    if (edition === 'bar') {
        return barDrinks;
    } else {
        return homeDrinks;
    }
}